export enum CredentialsType {
  AGENT_IN_LENDER_CONTEXT = 'agent_in_lender_context',
  AGENT_IN_SINGLE_PAYMENT_PROVIDER_CONTEXT = 'agent_in_single_payment_provider_context',
}
